// Firestore collection names. All collections owned by this app are
// prefixed `closing-` so they coexist with the other apps sharing the
// cv-priorities Firebase project (pipeline-*, deals, teamThoughts, ...).
export const COL_CHECKLISTS = "closing-checklists";
export const COL_TEMPLATES = "closing-templates";
export const COL_DOCS = "closing-docs";
export const COL_RECOMMENDATIONS = "closing-recommendations";
// Shared collections owned by deal-pipeline-crm (read-only here, except
// pipeline-users where each user writes their own FCM tokens).
export const COL_PIPELINE_DEALS = "pipeline-deals";
export const COL_PIPELINE_USERS = "pipeline-users";
export const DEFAULT_TEMPLATE_ID = "default";
// Deal stages (owned by the CRM; listed for filtering).
export const STAGES = [
    "Pre-Call",
    "Post-Call",
    "Pre-Screen",
    "Screen Ready",
    "Term Sheet",
    "Legal",
    "Post-Closing",
];
/**
 * Stages where a closing checklist is relevant. The Deals page shows a deal
 * by default only when it's in one of these stages AND status is Active —
 * or when it already has a checklist (kept for posterity after closing).
 */
export const CHECKLIST_STAGES = ["Legal", "Post-Closing"];
// Upload limits — same values as document-review.
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024; // 25 MB
export const PDF_MIME = "application/pdf";
export const DOCX_MIME = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
/** Soft cap on items per checklist — the doc must stay well under 1 MB. */
export const MAX_ITEMS_PER_CHECKLIST = 400;
/** Cap on per-closing expansion when accepting a per_closing recommendation. */
export const MAX_CLOSING_EXPANSION = 10;
export const CRM_BASE_URL = "https://crm.julianfife.com";
export const APP_BASE_URL = "https://closing.julianfife.com";
